
import React from "react";
import "../App.css";

function Footer(){
return(
     <div id="Footer" className="footer-bottom">
  <h3>Made with ❤ by Logapriya B</h3>
  <p>© 2026 All Rights Reserved</p>
</div>
)
}

export default Footer;